import React, {useMemo} from 'react';

import {yupResolver} from '@hookform/resolvers/yup';
import {useGate, useStore} from 'effector-react';
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {$allowedActionsForInvoice, DocumentsGate} from 'models/documents/invoices/common';

import {updatePageValues, $pageValues, goNextPage} from 'models/documents/invoices/create';

import {PageValues} from 'types/invoices';

import {ControlSection} from '../../ControlSection';

import {formData} from '../../FormsData/Documents';

import {UniController} from '../../universalController';

import {Root, Grid, Headline} from './styled';
import {createIsFieldRequired, createValidationContext, generalInfoSchema} from './validation';

export const InvoiceDocumentsTab = () => {
    const {t} = useTranslation();
    const allowedActionsForInvoice = useStore($allowedActionsForInvoice);
    useGate(DocumentsGate);
    const pageValuesStore = useStore($pageValues);

    const formContext = useMemo(() => createValidationContext(), []);

    const {
        control,
        setValue,
        trigger,
        handleSubmit,
        formState: {errors},
    } = useForm<PageValues>({
        defaultValues: {...pageValuesStore},
        resolver: yupResolver(generalInfoSchema),
        context: formContext,
    });

    const isFieldRequired = useMemo(() => createIsFieldRequired(formContext), [formContext]);

    const onSubmit = (data: PageValues) => {
        updatePageValues(data);
        goNextPage();
    };
    const GEN_INFO = 'pages.documents.invoices.create.documents';

    const formDataList = formData(t, allowedActionsForInvoice.edit, isFieldRequired);

    return (
        <Root>
            <Headline>{t(`${GEN_INFO}.headlines.relatedDocuments`)}</Headline>
            <Grid columns={'1fr 1fr 1fr'}>
                {formDataList.general.map((item, index) => (
                    <UniController
                        key={`${index}_${item.name}}`}
                        item={item}
                        index={index}
                        errors={errors}
                        control={control}
                        setValue={setValue}
                        trigger={trigger}
                    />
                ))}
            </Grid>
            <Grid columns={'1fr 1fr'}>
                {formDataList.generalSecondHalf.map((item, index) => (
                    <UniController
                        key={`${index}_${item.name}}`}
                        item={item}
                        index={index}
                        errors={errors}
                        control={control}
                        setValue={setValue}
                        trigger={trigger}
                    />
                ))}
            </Grid>
            <Grid columns={'1fr 1fr'}>
                {formDataList.additional.map((item, index) => (
                    <UniController
                        key={`${index}_${item.name}}`}
                        item={item}
                        index={index}
                        errors={errors}
                        control={control}
                        setValue={setValue}
                        trigger={trigger}
                    />
                ))}
            </Grid>
            <ControlSection onSubmit={handleSubmit(onSubmit)} />
        </Root>
    );
};
